<div class="row mb-1" *ngFor="let record of list" style="max-height:60vh; overflow:auto">
    <div class="col-md-2">
        <small *ngIf="!record.date">Oggi</small>
        <small>{{record.date | date:'EEEE dd/MM/yyyy'}}</small>       
    </div>
    <div class="col-md-8">
        <textarea id="inputDescription" class="form-control form-control-sm" 
            rows="1" onblur="this.rows=1;" onfocus="this.rows=4;" 
            [(ngModel)]="record.value" placeholder="Scrivi il testo..."
            (change)="record.state=1" >
        </textarea>
    </div>
    <div class="col-md-2 float-right">        
        <a class="btn text-danger float-right"  title="Elimina nota" (click)="deleteRecord(record)"><i class="far fa-trash-alt"></i></a>
        <a class="btn float-right" (click)="record.state==2?record.state=1:record.state=2">
            <i *ngIf="record.state==2" title="Segna da leggere" class="far fa-envelope-open text-gray"></i>
            <i *ngIf="record.state==1 || !record.state" title="Segna come letta" class="far fa-envelope"></i>
        </a>
    </div>
</div>
<a (click)="newRecord()" class="btn btn-sm btn-outline-success"  title="Aggiungi nota"><i class="fa fa-plus"></i> Aggiungi nota</a>